<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="OMS工厂传单实时数据 center_10"
      :rightTitle="`${formatTime(this.dateData, 'yyyy-MM-dd')} 合计 ${
        pieChartData.all_order ? pieChartData.all_order.total_order_num : 0
      }单 ${
        pieChartData.all_order ? pieChartData.all_order.total_cabinet_num : 0
      }个柜子`"
    >
    </chart-title>
    <div class="two_col">
      <date-change-card
        height="100%"
        @leftClick="leftClick"
        @rightClick="rightClick(1)"
      >
        <div slot="main" style="height: 100%">
          <el-row :gutter="10" style="height: 48%">
            <el-col :span="8" class="num_card">
              <div
                class="num_card_item"
                v-for="(item, index) in this.barData"
                :key="index"
              >
                <div class="right_line">
                  <dv-decoration-6 style="width: 54px; height: 10px" />
                </div>
                <div class="num_card_item_title">{{ item.name }}</div>
                <div class="num_card_item_num">
                  <span class="num">{{ item.value }}</span>
                  <!-- <span class="unit">元</span> -->
                </div>
              </div>
              <!-- <div class="loader loader-4"></div> -->
            </el-col>
            <el-col :span="16" style="position: relative"
              ><div id="center_10_top" />
            </el-col>
          </el-row>
          <div id="center_10_bottom" />
          <div class="center_10_sh_order">
            {{ formatTime(dateData, "yyyy-MM-dd") }} 售后订单数：{{
              pieChartData.all_order
                ? pieChartData.all_order.after_sales_num
                : 0
            }}
          </div>
        </div>
      </date-change-card>
    </div>
  </div>
</template>

<script>
import { getDailyOrder } from "@/api/cockpit/vrhouse";
import { monthlySalesData } from "@/api/cockpit/jyl";
import {
  formatTime,
  getNextDate,
} from "@/utils/index";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
export default {
  mixins: [resize],
  name: "center_10",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chartLeft: null,
      chartRight: null,
      pieChartData: [],
      bottomChartData: [],
      barData: [],
      dateData: new Date(),
      config: {
        rowNum: 4,
        headerBGC: "transparent", // 表头背景色
        oddRowBGC: "transparent", // 奇数行背景色
        evenRowBGC: "transparent", // 偶数行背景色
        waitTime: 2000, // 轮播时间间隔(ms)
        // columnWidth: [300, ""],
        align: ["center", "center"],
        data: [],
      },
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },

  beforeDestroy() {
    if (!this.chartLeft && !this.chartRight) {
      return;
    }
    this.chartLeft.dispose();
    this.chartLeft = null;
    this.chartRight.dispose();
    this.chartRight = null;
  },
  methods: {
    formatTime,
    //获取商家每日订单统计数据
    getData() {
      getDailyOrder({
        search_time: formatTime(this.dateData, "yyyy-MM-dd"),
      }).then((resp) => {
        this.pieChartData = resp.data.amount;
        this.barData = [
          {
            value: this.pieChartData.platform_cabinet_list.jyl,
            name: "家由莱",
          },
          {
            value: this.pieChartData.platform_cabinet_list.hd,
            name: "宏度",
          },
          {
            value: this.pieChartData.platform_cabinet_list.zt,
            name: "展厅",
          },
        ];
        // const data = [
        //   [
        //     `<span style="color:#409EFF">转图完成：</span>`,
        //     `<span style="color:#409EFF">今日合计${this.pieChartData.transfer_complete}单</span>`,
        //   ],
        //   [
        //     `<span style="color:#409EFF">审图完成：</span>`,
        //     `<span style="color:#409EFF">今日合计${this.pieChartData.drawing_review_completed}单</span>`,
        //   ],
        //   [
        //     `<span style="color:#409EFF">开单完成：</span>`,
        //     `<span style="color:#409EFF">今日合计${this.pieChartData.billing_completed}单</span>`,
        //   ],
        //   [
        //     `<span style="color:#409EFF">商家下单：</span>`,
        //     `<span style="color:#409EFF">今日合计${this.pieChartData.merchant_place_order}单</span>`,
        //   ],
        // ];
        // this.config.data = data;
        // this.config = { ...this.config };
        this.bottomChartData = resp.data.list;
        this.$nextTick(() => {
          this.initChart();
        });
      });
    },
    initChart() {
      this.chartLeft = this.$echarts.init(
        document.getElementById("center_10_top")
      );
      this.setOptions();
      this.chartRight = this.$echarts.init(
        document.getElementById("center_10_bottom")
      );
      this.setOptionsBottom();
    },
    setOptions() {
      const color = [
        "#1158a7",
        "#59abf6",
        "#29beb9",
        "#3bffd0",
        "#22e4ff",
        "#40E0D0",
      ];
      const valArr = this.barData.map((m) => m.value);
      const maxVal = Math.max(...valArr);
      this.chartLeft.setOption({
        title: {
          subtext: `${formatTime(this.dateData, "yyyy-MM-dd")} 传厂订单柜子数`,
          right: "right",
          subtextStyle: {
            color: "#C0C4CC",
          },
        },
        polar: {
          radius: [35, "68%"],
        },
        radiusAxis: {
          max: maxVal + 10,
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
            },
          },
        },
        angleAxis: {
          type: "category",
          data: this.barData.map((m) => m.name),
          startAngle: 75,
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          axisLabel: {
            color: "#C0C4CC",
          },
        },

        tooltip: {},
        series: {
          type: "bar",
          data: this.barData.map((m, index) => {
            return {
              value: m.value,
              itemStyle: {
                color: color[index],
              },
              label: {
                color: "#ffffff",
              },
            };
          }),
          coordinateSystem: "polar",
          label: {
            show: true,
            position: "inside",
            formatter: "{c}",
          },
        },
      });
    },
    setOptionsBottom() {
      this.chartRight.setOption({
        title: {
          subtext: `${formatTime(this.dateData, "yyyy-MM-dd")} 商家传单情况`,
          left: "left",
          subtextStyle: {
            color: "#C0C4CC",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          left: "12%",
          right: "12%",
          bottom: "16%",
          containLabel: true,
        },
        legend: {
          data: ["订单数", "柜子数"],
          bottom: "3%",
          textStyle: {
            color: "#C0C4CC",
            fontSize: "10",
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.bottomChartData.map((m) => m.merchant_name),
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              color: "#909399",
              fontSize: "10",
              interval: 0, // 坐标轴刻度标签的显示间隔
              rotate: 30, // 标签倾斜的角度
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#606266",
                type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
              },
            },
          },
          {
            show: false,
          },
        ],
        series: [
          {
            name: "订单数",
            type: "bar",
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "rgba(21,157,255,0.1)" },
                { offset: 1, color: "rgba(21,157,255,1)" },
              ]),
            },
            data: this.bottomChartData.map((m) => m.order_num),
          },
          {
            name: "柜子数",
            type: "bar",
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
              color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "rgba(34,228,255,0.1)" },
                { offset: 1, color: "rgba(34,228,255,1)" },
              ]),
            },
            data: this.bottomChartData.map((m) => m.cabinet_num),
          },
        ],
      });
    },
    //前一日
    leftClick() {
      this.dateData = getNextDate(formatTime(this.dateData, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一日
    rightClick() {
      this.dateData = getNextDate(formatTime(this.dateData, "yyyy-MM-dd"), +1);
      this.getData();
    },
    //数字大写转换
    numberConvert(val) {
      let num = "";
      switch (val) {
        case "1":
          num = "一";
          break;
        case "2":
          num = "二";
          break;
        case "3":
          num = "三";
          break;
        case "4":
          num = "四";
          break;
        case "5":
          num = "五";
          break;
        case "6":
          num = "六";
          break;
        case "7":
          num = "七";
          break;
        case "8":
          num = "八";
          break;
        case "9":
          num = "九";
          break;
        case "10":
          num = "十";
          break;
        case "11":
          num = "十一";
          break;
        case "12":
          num = "十二";
          break;
        default:
          break;
      }
      return num;
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 75vh;
  .two_col {
    padding: 0 10px;
    height: calc(100% - 30px);
    .num_card {
      padding-left: 20px !important;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-end;
      .num_card_item {
        position: relative;
        width: 160px;
        background: radial-gradient(
          rgba(89, 132, 173, 0.45) 20%,
          rgba(89, 132, 173, 0.05) 80%
        );
        color: #8fb5db;
        border: 2px solid #0c2b4a;
        padding: 10px 12px;
        border-radius: 5px;
        .right_line {
          position: absolute;
          top: -6px;
          right: 0px;
        }
        .num_card_item_title {
          font-size: 14px;
          font-weight: bold;
        }
        .num_card_item_num {
          margin-top: 12px;
          .num {
            font-size: 24px;
            font-weight: bold;
          }
          .unit {
            margin-left: 5px;
            font-weight: bold;
          }
        }
      }
    }
    .center_10_sh_order {
      height: 10%;
      color: #c0c4cc;
      padding-top: 10px;
    }
    .center_10_scroll {
      height: 20%;
    }
  }
  #center_10_top {
    height: 100%;
  }
  #center_10_bottom {
    height: 42%;
  }
}
</style>
